import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { getCatalogService } from '@asd-stan/standard/infrastructure/getters';
import { ReactComponent as LogoIcon } from '@asd-stan/ui-kit/assets/asd-stan.svg';
import { BreadCrumbs } from '@components/bread-crumbs/bread-crumbs';
import { EmptyTableSearch } from '@components/content-table/empty-table-search';
import { Loading } from '@components/loading/loading';
import { PageTitle } from '@components/page-title/page-title';
import { Flex } from '@components/utility/flex';

import { CatalogItemForm } from './catalog-item-form';

import { StyledLoaderContainer } from '@asd-stan/standard/components/single-standard/tabs-sections/single-standard-page-section/single-standard.styled';
import { ContentContainer } from '@components/utility/content-container.styled';

const CATALOG_LIST_PATH = '/standards/catalog';

export const SingleCatalogItemPage: React.FC = observer(() => {
	const { t } = useTranslation();
	const params = useParams();
	const navigate = useNavigate();
	const catalogService = getCatalogService();

	const id = Number(params.id);

	useEffect(() => {
		if (id) {
			catalogService.getCatalogItemById(id);
		}

		return () => catalogService.clearCatalogItem();
	}, [id]);

	const goToList = () => navigate(CATALOG_LIST_PATH);

	if (catalogService.catalogItemNotFound) {
		return (
			<ContentContainer>
				<BreadCrumbs />
				<EmptyTableSearch emptySearchText={t('standard.catalog.itemNotFound')} />
			</ContentContainer>
		);
	}

	if (!catalogService.catalogItem) {
		return (
			<ContentContainer>
				<StyledLoaderContainer>
					<Flex $align="center" $justify="center" $direction="column">
						<LogoIcon />
						<Loading horizontal />
					</Flex>
				</StyledLoaderContainer>
			</ContentContainer>
		);
	}

	return (
		<ContentContainer>
			<BreadCrumbs />
			<PageTitle title={t('standard.catalog.modal.title')} />
			<CatalogItemForm
				item={catalogService.catalogItem}
				onCancel={goToList}
				onSuccess={goToList}
			/>
		</ContentContainer>
	);
});
